import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Role } from '../../setting/expert/expert.const';
import {
  getDisplayGroupColumn,
  getDisplayNameColumn,
  getDisplayRoleColumn,
  getDisplayStatusColumn,
  getDisplayTypeColumn,
  getDisplayUserNameColumn,
  getName,
} from './call-monitor.const';
import { BaseListComponent } from '../../../../../components/base-list.component';
import { Observable } from 'rxjs';
import { GroupService } from '../../../../../common/services/Group.service';
import { UserService } from '../../../../../common/services/User.service';
import { SocketService } from '../../../../../common/services/Socket.service';
import { isPhoneNumber } from '../../../../../common/utils/validate';
import { FormFieldType, ModalType } from '../../../../../components/modals/modal-form-template/modal-form.const';
import { AgentModalType } from '../../../../../components/modals/agent-modal/agent-modal.const';
import * as _ from 'lodash';
import { MonitorTab, MonitorTabList } from '../monitors.const';
import { showPhoneNumberInString } from '../../../../../common/utils/common';

declare var $: any;

@Component({
  selector: 'monitors-call-monitor',
  templateUrl: './call-monitor.component.html',
  styleUrls: ['./call-monitor.component.css'],
})
export class CallMonitorComponent extends BaseListComponent implements OnChanges, AfterViewInit {
  @ViewChild('templateAgent') templateAgent: ElementRef;
  @ViewChild('templateInvite') templateInvite: ElementRef;

  @Input() callList: any = [];
  @Input() timer: any = [];
  @Output() onChangeTab: EventEmitter<{ tab: any }> = new EventEmitter();

  public modalAgentType = AgentModalType.AGENT_READY_TO_CALL;
  public filterStatus = [
    { id: '-1', text: 'Trạng thái cuộc gọi' },
    { id: 'QUEUEING', text: 'Trong hàng đợi' },
    { id: 'RINGING', text: 'Đang đổ chuông' },
    { id: 'ANSWERING', text: 'Đang trả lời' },
    { id: 'MUTING', text: 'Đang tắt mic' },
    { id: 'HOLDING', text: 'Đang giữ máy' },
    { id: 'DIALING', text: 'Đang kết nối' },
  ];
  public filterGroup = [];
  public groups = [];
  public list = [];
  public allStatus = [];
  public sortBy = 'username';
  public sortAsc = true;
  public sortArray = [
    { id: 'username', text: 'Username' },
    { id: 'display_group', text: 'Bộ phận' },
    { id: 'status', text: 'Trạng thái cuộc gọi' },
  ];
  pun;

  public modelFilter: any = {};
  public allGroups = [];
  public allAgents = [];
  public currentCall: any = {};
  public readonly Role = Role;
  public delayLoad = false;
  public readonly tabList = MonitorTabList;
  public readonly MonitorTab = MonitorTab;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    protected groupService: GroupService,
    protected userService: UserService,
    protected socketService: SocketService
  ) {
    super(changeDetector, toastr, modalService);
  }

  async ngOnInit() {
    this.modelFilter = {};
    Observable.forkJoin([this.loadAgents(), this.loadGroups()]).subscribe(() => {
      this.loadData().then();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadData().then();
  }

  ngAfterViewInit(): void {}

  loadAgents() {
    return this.userService.all({}).map(res => {
      if (res.status == 200 && !res.error) {
        this.allAgents = res.data.list;
      }
    });
  }

  loadGroups() {
    return this.groupService.allGroup({ target: 'user' }).map(res => {
      if (res.status == 200 && !res.error) {
        let groups = [{ id: '-1', text: 'Bộ phận' }];
        this.allGroups = res.data.filter(g => g.target === 'user');
        for (let group of this.allGroups) {
          groups.push({ id: group.id, text: group.name });
        }
        this.filterGroup = groups;
      }
    });
  }

  async loadData() {
    let list = this.callList.map(res => res);
    if (this.modelFilter.keyword) {
      list = list.filter(r => r.username.toLowerCase().includes(this.modelFilter.keyword.toLowerCase()));
    }
    if (this.modelFilter.status) {
      list = list.filter(r => r.status === this.modelFilter.status);
    }
    if (this.modelFilter.group_id) {
      list = list.filter(r => r.groupId === this.modelFilter.group_id);
    }
    this.initPage(list.length);
    setTimeout(() => {
      this.data = list
        .map(r => {
          r.name = getName(r, this.allAgents);
          r.display_name = getDisplayNameColumn(r, this.allAgents);
          r.display_username = getDisplayUserNameColumn(r, this.allAgents);
          r.display_role = getDisplayRoleColumn(r, this.user);
          r.display_group = getDisplayGroupColumn(r, this.allGroups);
          r.display_status = getDisplayStatusColumn(r);
          r.display_type = getDisplayTypeColumn(r);
          r.display_caller = showPhoneNumberInString(r.caller, this.user);
          return r;
        })
        .sort((a, b) => {
          if (this.sortBy === 'username') {
            return this.sortAsc ? a.username.localeCompare(b.username) : b.username.localeCompare(a.username);
          } else if (this.sortBy === 'display_role') {
            return this.sortAsc
              ? a.display_role.localeCompare(b.display_role)
              : b.display_role.localeCompare(a.display_role);
          } else if (this.sortBy === 'display_group') {
            return this.sortAsc
              ? a.display_group.localeCompare(b.display_group)
              : b.display_group.localeCompare(a.display_group);
          } else if (this.sortBy === 'status') {
            return this.sortAsc ? a.status.localeCompare(b.status) : b.status.localeCompare(a.status);
          } else {
            return 0;
          }
        });
      this.is_loading = false;
    }, 100);
  }

  changeFilter($event, key) {
    let value = $event.value;
    if (value === '-1') {
      value = '';
    }
    if (key === 'sortBy') {
      this.sortBy = value;
    } else {
      this.modelFilter[key] = value;
    }
    this.loadData().then();
  }

  listen(call: any) {
    if (!call.answered) {
      this.throwWarning('Cuộc gọi chưa trả lời!');
      return;
    }
    let data = { action: 'listen', callId: call.callId };
    this.socketService.interact(data);
  }

  join(call: any) {
    if (!call.answered) {
      this.throwWarning('Cuộc gọi chưa trả lời!');
      return;
    }
    let data = { action: 'join', callId: call.callId };
    this.socketService.interact(data);
  }

  transfer(call: any) {
    if (!call.answered) {
      this.throwWarning('Cuộc gọi chưa trả lời!');
      return;
    }
    this.closeModal();
    let data = { action: 'transfer', callId: call.callId };
    this.socketService.interact(data);
  }

  disconnect(call: any) {
    let data = { action: 'disconnect', callId: call.callId };
    this.socketService.interact(data);
  }

  transferToAgent(agentId: any) {
    if (!this.currentCall.answered) {
      this.throwWarning('Cuộc gọi chưa trả lời!');
      return;
    }
    this.closeModal();
    let data = {
      action: 'transfer',
      callId: this.currentCall.callId,
      to: agentId,
    };
    this.socketService.interact(data);
  }

  toOutPhone(phoneNumber) {
    if (!this.currentCall.answered) {
      this.throwWarning('Cuộc gọi chưa trả lời!');
      return;
    }
    this.closeModal();
    let data = {
      action: 'invitephone',
      callId: this.currentCall.callId,
      to: phoneNumber,
    };
    this.socketService.interact(data);
  }

  async setupModel() {
    this.modelContent = {
      type: ModalType.Primary,
      title: 'Mời tham gia',
      submit_title: 'Mời',
    };
    this.modelDisplay = [
      {
        key: 'phone_out',
        label: 'Số điện thoại',
        type: FormFieldType.Text,
        value: this.model.phone_out,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
      },
    ];
  }

  async handleAction(key: any, item: any) {
    let config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-md',
      keyboard: false,
    };
    switch (key) {
      case 'disconnect':
        this.disconnect(item);
        break;
      case 'listen':
        this.currentCall = item;
        this.listen(item);
        break;
      case 'join':
        this.currentCall = item;
        this.join(item);
        break;
      case 'invite':
        this.currentCall = item;
        await this.setupModel();
        this.openModal(this.templateInvite, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case 'transfer':
        this.currentCall = item;
        this.modelContent = {
          type: ModalType.Primary,
          title: 'Chuyển cho chuyên viên',
        };
        config.class = 'modal-xxl';
        this.openModal(this.templateAgent, config);
        break;
      case 'transferToAgent':
        this.transferToAgent(item.agent_id);
        break;
      default:
        break;
    }
  }

  async handleSubmit(item?: any) {
    this.model = _.merge({}, this.model, item);
    this.toOutPhone(item.phone_out);
  }

  async onChangeValueModel(key, item?: any) {
    this.model = _.merge({}, this.model, item);
    this.message = null;
    if (this.model.phone_out && !isPhoneNumber(this.model.phone_out)) {
      this.message = this.message = {
        class: 'alert dark alert-danger',
        content: 'Số điện thoại không hợp lệ!',
      };
    }
    await this.setupModel();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/monitors/call-monitor/call-monitor.component.ts